import {Fragment} from 'react';
import {Link, useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, Message, Segment} from 'semantic-ui-react';
import {convertDateTimeToString} from '../../../utils/datetime';

function ConsultPackageError(props) {
  const location = useLocation();
  if (location.pathname === '/consult-packages') return null;

  const message = props.expireTime ?
    `         داوطلب گرامی زمان بسته مشاوره شما در تاریخ
      ${convertDateTimeToString(props.expireTime)}
      به اتمام رسیده است.`
    : null;
  return (
    <Fragment>
      {message && (<Message error content={message} className='text-center'/>)}
      {props.showLink && (
        <Segment className='text-center'>
          <p>
            داوطلب گرامی لطفا با مراجعه به صفحه
            &nbsp;
            <Link to='/consult-packages'>بسته‌های مشاوره</Link>
            &nbsp;
            ، بسته مشاوره دلخواه خود را انتخاب کنید.
          </p>
          <Button positive as={Link} to='/consult-packages'>
            بسته‌های مشاوره
          </Button>
        </Segment>
      )}
    </Fragment>
  );
}

ConsultPackageError.propTypes = {
  showLink: PropTypes.bool.isRequired,
  expireTime: PropTypes.string
};

ConsultPackageError.defaultProps = {
  showLink: true
};


export default ConsultPackageError;
